/* Hover disclosures and linked parent categories, isolated from Gearx accordions. */
(() => {
  if (customElements.get('jss-mega-menu')) return;
  class JssMegaMenu extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const on = (node, event, fn, options = {}) => node.addEventListener(event, fn, { ...options, signal: this.controller.signal });
      this.details = this.querySelector('.jss-mega__disclosure');
      this.trigger = this.querySelector('.jss-mega__trigger');
      this.panel = this.querySelector('.jss-mega__panel');
      this.categories = [...this.querySelectorAll('[data-mega-target]')];
      this.groups = [...this.querySelectorAll('[data-mega-group]')];
      this.contexts = [...this.querySelectorAll('[data-mega-context]')];
      this.layout = this.querySelector('.jss-mega__layout');
      this.mobile = matchMedia('(max-width: 1023px)');
      if (!this.details || !this.categories.length) return;
      this.categories.forEach(button => button.setAttribute('aria-controls', button.dataset.megaTarget));
      this.select(this.categories[0]);
      this.trigger.setAttribute('aria-expanded', String(this.details.open));
      this.classList.add('is-ready');
      this.classList.toggle('jss-mega--single-panel', this.groups.length === 1);
      this.prepareMobileGroups();
      this.syncLayout();
      on(this.details, 'toggle', () => {
        this.trigger.setAttribute('aria-expanded', String(this.details.open));
        if (!this.details.open) { this.classList.remove('show-mobile-panel'); return; }
        document.querySelectorAll('jss-mega-menu').forEach(menu => { if (menu !== this) menu.close(); });
        document.querySelectorAll('nav.nav-sections li.level0.is-open').forEach(li => li.classList.remove('is-open'));
        this.fit();
      });
      on(this, 'pointerenter', e => {
        if (e.pointerType !== 'mouse' || this.mobile.matches) return;
        clearTimeout(this.closeTimer);
        if (this.dataset.hoverOpen === 'true' && !this.details.open) {
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => this.open(), 100);
        }
      });
      on(this, 'pointerleave', e => {
        if (e.pointerType !== 'mouse' || this.mobile.matches) return;
        clearTimeout(this.openTimer);
        clearTimeout(this.hoverTimer);
        clearTimeout(this.closeTimer);
        // Forgive brief departures and diagonal movement into the full-width panel.
        this.closeTimer = setTimeout(() => {
          if (!this.matches(':hover')) this.close(this.panel.contains(document.activeElement));
        }, 260);
      });
      on(this, 'pointerover', e => {
        const row = e.target.closest('[data-mega-row]');
        const button = row?.querySelector('[data-mega-target]');
        if (!button || this.dataset.hover !== 'true' || this.mobile.matches || e.pointerType !== 'mouse') return;
        if (row.contains(e.relatedTarget)) return;
        clearTimeout(this.hoverTimer);
        this.hoverTimer = setTimeout(() => {
          if (!this.panel.contains(document.activeElement) || document.activeElement?.closest('[data-mega-row]')) this.select(button);
        }, 120);
      });
      on(this, 'pointerout', e => {
        const row = e.target.closest('[data-mega-row]');
        if (row && !row.contains(e.relatedTarget)) clearTimeout(this.hoverTimer);
      });
      on(this, 'click', e => {
        const row = e.target.closest('[data-mega-row]');
        const button = e.target.closest('[data-mega-target]') ||
          (this.mobile.matches && row?.querySelector('[data-mega-target]'));
        if (button) {
          e.preventDefault();
          const collapse = this.mobile.matches && this.activeCategory?.dataset.megaTarget === button.dataset.megaTarget &&
            this.groups.some(group => group.id === button.dataset.megaTarget && !group.hidden);
          if (collapse) this.collapseMobile();
          else this.select(button);
        }
      });
      on(this, 'focusin', e => {
        clearTimeout(this.closeTimer);
        if (this.mobile.matches) return;
        const button = e.target.closest('[data-mega-row]')?.querySelector('[data-mega-target]');
        if (button) this.select(button);
      });
      on(this, 'keydown', e => {
        if (e.key === 'Escape' && this.details.open) {
          e.preventDefault(); e.stopPropagation(); this.close(true); return;
        }
        if (e.target === this.trigger && e.key === 'ArrowDown') {
          e.preventDefault(); this.open();
          this.querySelector('.jss-mega__sidebar a, .jss-mega__sidebar button')?.focus(); return;
        }
        if (this.mobile.matches && e.key === ' ' && e.target.matches('a.jss-mega__category[role="button"]')) {
          e.preventDefault(); e.target.click(); return;
        }
        if (!e.target.closest('.jss-mega__sidebar')) return;
        const button = e.target.closest('[data-mega-row]')?.querySelector('[data-mega-target]');
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(e.key)) {
          e.preventDefault();
          const links = [...this.querySelectorAll('.jss-mega__category[href], button.jss-mega__category')];
          if (!links.length) return;
          const rowLink = e.target.closest('[data-mega-row]')?.querySelector('a') || e.target;
          let index = links.indexOf(rowLink);
          index = e.key === 'Home' ? 0 : e.key === 'End' ? links.length - 1 : (index + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
          links[index].focus();
        }
        if (e.key === 'ArrowRight' && button && !this.mobile.matches) {
          e.preventDefault(); this.select(button);
          this.groups.find(group => !group.hidden)?.querySelector('a')?.focus();
        }
      });
      on(document, 'click', e => { if (!this.contains(e.target)) this.close(); });
      on(document, 'focusin', e => { if (!this.contains(e.target)) this.close(); });
      on(window, 'resize', () => this.fit());
      on(this.mobile, 'change', () => { this.close(); this.syncLayout(); });
      const drawer = this.closest('.col-header-center');
      if (drawer) {
        this.observer = new MutationObserver(() => { if (this.mobile.matches && !drawer.classList.contains('open-header-menu')) this.close(); });
        this.observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
      on(document, 'shopify:block:select', e => {
        const selected = String(e.detail?.blockId || '');
        const promo = [...this.querySelectorAll('[data-jss-promo-id]')].find(p => p.dataset.jssPromoId === selected);
        const row = [...this.querySelectorAll('[data-mega-category-block]')].find(p => p.dataset.megaCategoryBlock === selected);
        if (selected !== this.dataset.blockId && !promo && !row) return;
        // A shared category is rendered in two parents. Open its first parent only.
        const owners = [...document.querySelectorAll('jss-mega-menu')].filter(m => [...m.querySelectorAll('[data-mega-category-block], [data-jss-promo-id]')].some(n => n.dataset.megaCategoryBlock === selected || n.dataset.jssPromoId === selected));
        if (owners.length && owners[0] !== this) return;
        const owner = row?.dataset.megaCategoryBlock || promo?.closest('[data-mega-context]')?.dataset.megaContext;
        const group = this.groups.find(g => g.dataset.megaOwner === owner);
        this.select(this.categories.find(b => b.dataset.megaTarget === group?.id) || this.categories[0]);
        if (this.mobile.matches && drawer) drawer.classList.add('open-header-menu');
        this.open();

      });
    }
    prepareMobileGroups() {
      this.mobileGroups = this.groups.map(group => {
        const button = this.categories.find(item => item.dataset.megaTarget === group.id);
        const row = button?.closest('[data-mega-row]');
        if (!row) return null;
        const marker = document.createComment('Mega menu desktop group');
        group.before(marker);
        const wrapper = document.createElement('div');
        wrapper.className = 'jss-mega__mobile-category';
        const link = row.querySelector('a.jss-mega__category[href]');
        if (link && link.getAttribute('href') !== '#') {
          const shopAll = document.createElement('a');
          shopAll.className = 'jss-mega__shop-all';
          shopAll.href = link.href;
          shopAll.textContent = `Shop all ${link.textContent.trim()}`;
          group.prepend(shopAll);
        }
        return { group, row, marker, wrapper };
      }).filter(Boolean);
    }
    syncLayout() {
      this.mobileGroups.forEach(({ group, row, marker, wrapper }) => {
        const link = row.querySelector('a.jss-mega__category');
        if (link) {
          if (this.mobile.matches) {
            link.setAttribute('role', 'button');
            link.setAttribute('aria-controls', group.id);
          } else {
            link.removeAttribute('role');
            link.removeAttribute('aria-controls');
            link.removeAttribute('aria-expanded');
          }
        }
        if (this.mobile.matches) {
          row.before(wrapper);
          wrapper.append(row, group);
        } else {
          marker.after(group);
          if (wrapper.parentNode) wrapper.before(row);
          wrapper.remove();
        }
      });
      if (this.mobile.matches && this.groups.length > 1) this.collapseMobile();
      else this.select(this.activeCategory || this.categories[0]);
    }
    collapseMobile() {
      this.groups.forEach(group => { group.hidden = true; });
      this.categories.forEach(button => {
        button.setAttribute('aria-expanded', 'false');
        button.closest('[data-mega-row]')?.querySelector('a.jss-mega__category')?.setAttribute('aria-expanded', 'false');
        button.closest('[data-mega-row]')?.classList.remove('is-selected');
      });
      this.contexts.forEach(node => { node.hidden = true; });
      this.layout?.classList.remove('jss-mega__layout--promos');
    }
    open() {
      clearTimeout(this.openTimer); clearTimeout(this.closeTimer);
      this.details.open = true;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.fit();
    }
    select(button) {
      if (!button) return;
      const selectedGroup = this.groups.find(g => g.id === button.dataset.megaTarget);
      const owner = selectedGroup?.dataset.megaOwner || this.dataset.blockId;
      const changed = this.activeCategory?.dataset.megaTarget !== button.dataset.megaTarget;
      this.activeCategory = button;
      this.categories.forEach(item => {
        item.setAttribute('aria-expanded', String(item.dataset.megaTarget === button.dataset.megaTarget));
        if (this.mobile.matches) item.closest('[data-mega-row]')?.querySelector('a.jss-mega__category')?.setAttribute('aria-expanded', String(item.dataset.megaTarget === button.dataset.megaTarget));
        item.closest('[data-mega-row]')?.classList.toggle('is-selected', item.dataset.megaTarget === button.dataset.megaTarget);
      });
      this.groups.forEach(group => { group.hidden = group.id !== button.dataset.megaTarget; });
      this.contexts.forEach(node => { node.hidden = node.dataset.megaContext !== owner; });
      this.layout?.classList.toggle('jss-mega__layout--promos', this.contexts.some(n => !n.hidden && n.classList.contains('jss-mega__promotions--right')));
      if (changed && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        [selectedGroup, ...this.contexts.filter(n => !n.hidden)].filter(Boolean).forEach(n => n.animate([{ opacity: .3, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 180, easing: 'ease-out' }));
      }
      this.fit();
    }
    fit() {
      if (!this.details.open || this.mobile.matches) return;
      const top = this.panel.getBoundingClientRect().top;
      this.style.setProperty('--mega-available-height', `${Math.max(120, innerHeight - top - 16)}px`);
    }
    close(focus = false) {
      clearTimeout(this.openTimer); clearTimeout(this.closeTimer); clearTimeout(this.hoverTimer);
      if (!this.details) return;
      this.details.open = false;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.classList.remove('show-mobile-panel');
      if (focus) this.trigger.focus();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.observer?.disconnect();
      this.mobileGroups?.forEach(({ group, row, marker, wrapper }) => {
        marker.after(group);
        marker.remove();
        if (wrapper.parentNode) wrapper.before(row);
        wrapper.remove();
        group.querySelector('.jss-mega__shop-all')?.remove();
      });
      clearTimeout(this.openTimer); clearTimeout(this.closeTimer); clearTimeout(this.hoverTimer);
    }
  }
  customElements.define('jss-mega-menu', JssMegaMenu);
})();
